import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { canActivate, redirectUnauthorizedTo } from '@angular/fire/auth-guard';

import { PhishingShellComponent } from '@layout/phishing-shell/phishing-shell.component';

const redirectUnauthorizedToLogin = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return redirectUnauthorizedTo(`/auth/login?redirectTo=${state.url}`);
};

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/settings/start' },
  {
    path: 'admin',
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('@features/admin/admin.routes').then((module) => module.ADMIN_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.routes').then((module) => module.AUTH_ROUTES),
  },
  {
    path: 'phishing',
    component: PhishingShellComponent,
    ...canActivate(redirectUnauthorizedToLogin),
    children: [
      { path: '', redirectTo: 'phishing-dashboard', pathMatch: 'full' },
      {
        path: 'phishing-dashboard',
        loadChildren: () => import('@features/dashboard/dashboard.routes').then((module) => module.DASHBOARD_ROUTES),
      },
      {
        path: 'phishing-users-and-groups',
        loadChildren: () => import('@features/groups/groups.routes').then((module) => module.GROUPS_ROUTES),
      },
      {
        path: 'phishing-campaign-summary/:id',
        loadChildren: () =>
          import('@features/campaigns/campaigns.routes').then((module) => module.CAMPAIGN_SUMMARY_ROUTES),
      },
      {
        path: 'phishing-campaigns',
        loadChildren: () => import('@features/campaigns/campaigns.routes').then((module) => module.CAMPAIGNS_ROUTES),
      },
      {
        path: 'phishing-email-templates-dashboard',
        loadChildren: () =>
          import('@features/email-templates/email-templates.routes').then((module) => module.EMAIL_TEMPLATES_ROUTES),
      },
      {
        path: 'phishing-landing-pages-dashboard',
        loadChildren: () =>
          import('@features/landing-pages/landing-pages.routes').then((module) => module.LANDING_PAGES_ROUTES),
      },
      {
        path: 'phishing-learning-pages-dashboard',
        loadChildren: () =>
          import('@features/learning-pages/learning-pages.routes').then((module) => module.LEARNING_PAGES_ROUTES),
      },
      {
        path: 'certification',
        loadChildren: () =>
          import('@features/certificate/certificate.routes').then((module) => module.CERTIFICATE_ROUTES),
      },
    ],
  },
  {
    path: 'settings',
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('@features/settings/settings.routes').then((module) => module.SETTINGS_ROUTES),
  },
  {
    path: 'learningpage/:id',
    loadChildren: () =>
      import('@features/learning-pages/learning-pages.routes').then((module) => module.LEARNINGPAGE_REF_ROUTES),
  },
  { path: '**', redirectTo: '/settings/start' },
];
